import { useEffect, useState } from 'react';

export const isOwapApp = (): boolean => {
  if (typeof window === 'undefined') { return false; }
  return sessionStorage.getItem('owapApp') === 'true';
};

export type OwapWebviewType = 'page' | 'fullpage' | 'modal' | 'fullmodal';
export const getOwapWebviewType = (): OwapWebviewType | null => {
  if (typeof window === 'undefined') { return null; }
  return sessionStorage.getItem('owapWebviewType') as OwapWebviewType ?? null;
};

interface UseOwapInfoReturns {
  isOwap: boolean;
  owapWebviewType: OwapWebviewType | null;
}

export const useOwapInfo = (): UseOwapInfoReturns => {
  const [isOwap, setIsOwapApp] = useState(false);
  const [owapWebviewType, setOwapWebviewType] = useState<OwapWebviewType | null>(null);

  useEffect(() => {
    setIsOwapApp(isOwapApp());
    setOwapWebviewType(getOwapWebviewType());
  }, []);

  return {
    isOwap,
    owapWebviewType,
  };
};
